module.exports = __webpack_public_path__ + "static/media/pages.5b679ef7.png";